var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import IconAppSwitcher from "./icons/IconAppSwitcher";
import IconCloudCma from "./icons/IconCloudCma";
import IconCloudStreams from "./icons/IconCloudStreams";
import IconCloudMlx from "./icons/IconCloudMlx";
import IconCloudAttract from "./icons/IconCloudAttract";
import IconLaunchpad from "./icons/IconLaunchpad";
import { getConfiguration, transformConfiguration } from "./utils";
import { Container, Button, Menu, MenuItem, MenuIcon, MenuCopy, Title, Description } from "./styled/app-switcher";
var AppSwitcher = /** @class */ (function (_super) {
    __extends(AppSwitcher, _super);
    function AppSwitcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._mounted = false;
        _this.state = {
            isOpen: false,
            isEnabled: _this.props.forceEnabled || false,
            isCmaAvailable: _this.props.forceEnabled || false,
            isStreamsAvailable: _this.props.forceEnabled || false,
            isMlxAvailable: _this.props.forceEnabled || false,
            isAttractAvailable: _this.props.forceEnabled || false,
            isLaunchpadAvailable: _this.props.forceEnabled || false,
            urlForCma: "",
            urlForStreams: "",
            urlForMlx: "",
            urlForAttract: "",
            urlForLaunchpad: ""
        };
        _this.handleConfiguration = function (response) {
            if (!_this._mounted)
                return;
            var configs = transformConfiguration({ response: response, props: _this.props });
            if (_this.props.onConfigured)
                _this.props.onConfigured(configs);
            _this.setState(configs);
        };
        _this.handleButtonClick = function () {
            if (_this.state.isOpen)
                return;
            _this.setState({ isOpen: true });
            window.addEventListener("mouseup", _this.handleWindowClick);
        };
        _this.handleWindowClick = function () {
            if (!_this.state.isOpen)
                return;
            window.setTimeout(function () { return _this.setState({ isOpen: false }); }, 0);
            window.removeEventListener("mouseup", _this.handleWindowClick);
        };
        return _this;
    }
    AppSwitcher.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._mounted = true;
                        if (this.props.forceEnabled)
                            return [2 /*return*/];
                        if (!this.props.casJwt) return [3 /*break*/, 2];
                        return [4 /*yield*/, getConfiguration({
                                env: this.props.env || "development",
                                currentApp: this.props.currentApp,
                                userId: this.props.userId || "",
                                userEmail: this.props.userEmail || "",
                                casUserId: this.props.casUserId || "",
                                casJwt: this.props.casJwt,
                                mlsCode: this.props.mlsCode || ""
                            })];
                    case 1:
                        response = _a.sent();
                        this.handleConfiguration(response);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AppSwitcher.prototype.componentDidUpdate = function (_a) {
        var casJwt = _a.casJwt;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.props.forceEnabled)
                            return [2 /*return*/];
                        if (!(!casJwt && this.props.casJwt)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getConfiguration({
                                env: this.props.env || "development",
                                currentApp: this.props.currentApp,
                                userId: this.props.userId || "",
                                userEmail: this.props.userEmail || "",
                                casUserId: this.props.casUserId || "",
                                casJwt: this.props.casJwt,
                                mlsCode: this.props.mlsCode || ""
                            })];
                    case 1:
                        response = _b.sent();
                        this.handleConfiguration(response);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AppSwitcher.prototype.componentWillUnmount = function () {
        this._mounted = false;
    };
    AppSwitcher.prototype.render = function () {
        if (!this.state.isEnabled)
            return null;
        var _a = this.state, urlForCma = _a.urlForCma, urlForStreams = _a.urlForStreams, urlForMlx = _a.urlForMlx, urlForAttract = _a.urlForAttract;
        var isCma = this.props.currentApp === "cloud_cma";
        var isStreams = this.props.currentApp === "cloud_streams";
        var isMlx = this.props.currentApp === "cloud_mlx";
        var isAttract = this.props.currentApp === "cloud_attract";
        return (React.createElement(Container, { zIndex: this.props.zIndex },
            React.createElement(Button, { onClick: this.handleButtonClick },
                React.createElement(IconAppSwitcher, null)),
            this.state.isOpen && (React.createElement(Menu, null,
                this.state.isCmaAvailable && (React.createElement(MenuItem, { href: isCma ? undefined : urlForCma, isCurrentApp: isCma },
                    React.createElement(MenuIcon, null,
                        React.createElement(IconCloudCma, null)),
                    React.createElement(MenuCopy, null,
                        React.createElement(Title, null, "Cloud CMA"),
                        React.createElement(Description, null, "Reports and Homebeats")))),
                this.state.isStreamsAvailable && (React.createElement(MenuItem, { href: isStreams ? undefined : urlForStreams, isCurrentApp: isStreams },
                    React.createElement(MenuIcon, null,
                        React.createElement(IconCloudStreams, null)),
                    React.createElement(MenuCopy, null,
                        React.createElement(Title, null, "Cloud Streams"),
                        React.createElement(Description, null, "Listing alerts")))),
                this.state.isMlxAvailable && (React.createElement(MenuItem, { href: isMlx ? undefined : urlForMlx, isCurrentApp: isMlx },
                    React.createElement(MenuIcon, null,
                        React.createElement(IconCloudMlx, null)),
                    React.createElement(MenuCopy, null,
                        React.createElement(Title, null, "Cloud MLX"),
                        React.createElement(Description, null, "Search and organize")))),
                this.state.isAttractAvailable && (React.createElement(MenuItem, { href: isAttract ? undefined : urlForAttract, isCurrentApp: isAttract },
                    React.createElement(MenuIcon, null,
                        React.createElement(IconCloudAttract, null)),
                    React.createElement(MenuCopy, null,
                        React.createElement(Title, null, "Cloud Attract"),
                        React.createElement(Description, null, "Landing pages and leads")))),
                this.state.isLaunchpadAvailable && (React.createElement(MenuItem, { href: this.state.urlForLaunchpad, hasBorder: true },
                    React.createElement(MenuIcon, null,
                        React.createElement(IconLaunchpad, null)),
                    React.createElement(MenuCopy, null,
                        React.createElement(Title, null, "Launchpad"),
                        React.createElement(Description, null, "Learn and manage billing"))))))));
    };
    AppSwitcher.defaultProps = {
        env: "development",
        zIndex: 1000,
        onConfigured: function () { }
    };
    return AppSwitcher;
}(Component));
export default AppSwitcher;
